import { render, staticRenderFns } from "./AsideItem.vue?vue&type=template&id=53538766&scoped=true&"
import script from "./AsideItem.vue?vue&type=script&lang=ts&"
export * from "./AsideItem.vue?vue&type=script&lang=ts&"
import style0 from "./AsideItem.vue?vue&type=style&index=0&id=53538766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53538766",
  null
  
)

export default component.exports